(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp-auto-submit')) {
    class DpAutoSubmit extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          if (event.target instanceof HTMLSelectElement) {
            event.target.form?.requestSubmit();
          }
        });
      }
    }

    customElements.define('dp-auto-submit', DpAutoSubmit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-header-mega')) {
  class DpHeaderMega extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-mega-item]')];
      this.hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.closeTimer = null;

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('click', this.onDocumentClick);

      if (this.hoverable) {
        this.items.forEach((item) => {
          item.addEventListener('mouseenter', () => this.openNow(item));
          item.addEventListener('mouseleave', () => this.closeWithDelay());
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      window.clearTimeout(this.closeTimer);
    }

    onClick = (event) => {
      const trigger = event.target.closest('[data-mega-trigger]');
      if (!trigger) return;
      const item = trigger.closest('[data-mega-item]');
      const wasOpen = item.classList.contains('is-open');
      // Maus-Geräte: mouseenter hat den Punkt schon geöffnet – ein Klick auf den offenen
      // Punkt lässt ihn offen (QA 2026-09-16 P2-3). Geschlossen wird nur per Klick
      // außerhalb, Escape oder einen anderen Punkt. Auf Touch-Geräten (kein Hover)
      // bleibt Antippen ein Umschalter, sonst gäbe es dort keinen Weg zum Schließen.
      if (wasOpen && this.hoverable) return;
      this.closeAll();
      if (!wasOpen) this.openNow(item);
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      const openItem = this.items.find((item) => item.classList.contains('is-open'));
      if (!openItem) return;
      event.stopPropagation();
      this.closeAll();
      openItem.querySelector('[data-mega-trigger]')?.focus();
    };

    onFocusOut = () => {
      window.requestAnimationFrame(() => {
        if (!this.contains(document.activeElement)) this.closeAll();
      });
    };

    onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.closeAll();
    };

    openNow(item) {
      window.clearTimeout(this.closeTimer);
      this.closeAll();
      item.classList.add('is-open');
      item.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'true');
    }

    closeAll() {
      window.clearTimeout(this.closeTimer);
      this.items.forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      });
    }

    closeWithDelay() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.closeAll(), 150);
    }
  }

  customElements.define('dp-header-mega', DpHeaderMega);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-product-main"] && !Shopify.designMode) return;
  try {
    
  // Tinker scrollt in .page-wrapper statt im Dokument – die native Anker-Navigation
  // der Sprunglinks (#dp-connector) bewegt diesen Container nicht. Fokus wandert
  // mit, damit Tastatur- und Screenreader-Nutzung nach dem Sprung im Band weitergeht.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Eingeklapptes Konfigurator-Band: Der App-Block bleibt im DOM (die Brücke
  // bedient ihn auch verborgen), nur der Body ist hidden. Aufklappen über die
  // Teaser-Karte, die Sprunglinks, den URL-Hash oder das Ereignis
  // 'dp:connector-open' (dp-connector-bridge.js: „Konfigurator anzeigen").
  const connector = document.getElementById('dp-connector');
  const expandConnector = () => {
    if (!connector) return false;
    const body = connector.querySelector('[data-dp-connector-body]');
    const teaser = connector.querySelector('[data-dp-connector-teaser]');
    const toggle = connector.querySelector('[data-dp-connector-toggle]');
    if (!body || !body.hidden) return false;
    body.hidden = false;
    connector.classList.remove('dp-product-main__connector--collapsed');
    connector.removeAttribute('data-dp-connector-collapsed');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (teaser) teaser.hidden = true;
    return true;
  };
  window.dpExpandConnector = expandConnector;
  document.addEventListener('dp:connector-open', expandConnector);
  connector?.querySelector('[data-dp-connector-toggle]')?.addEventListener('click', () => {
    expandConnector();
    connector.querySelector('.dp-product-main__connector-heading')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    connector.focus({ preventScroll: true });
  });
  if (window.location.hash === '#dp-connector') expandConnector();

  document
    .querySelectorAll('.dp-product-main__cta[href^="#"], .dp-product-main__cta-secondary[href^="#"]')
    .forEach((cta) => {
      cta.addEventListener('click', (event) => {
        const target = document.querySelector(cta.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        if (target === connector) expandConnector();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        target.focus({ preventScroll: true });
        history.replaceState(null, '', cta.getAttribute('href'));
      });
    });

  // Formatkacheln (dp-format-picker.js) melden die Auswahl per `dp:format-change`;
  // hier übernehmen Preis und Designer-Links der Kaufspalte den neuen Stand.
  const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  const applyFormat = (detail) => {
    if (!detail) return;

    if (typeof detail.priceFrom === 'number') {
      document.querySelectorAll('[data-dp-price-amount]').forEach((root) => {
        const amount = root.querySelector('.price') ?? root;
        amount.textContent = euro.format(detail.priceFrom);
      });
      // „ab“ nur beim günstigsten Format des Produkts (data-dp-price-min, QA 2026-09-21 I-06);
      // sonst steht der Betrag ohne Kürzel, das Format nennt die Zeile darunter.
      const minPrice = Number(document.querySelector('[data-dp-price-min]')?.dataset.dpPriceMin);
      if (Number.isFinite(minPrice)) {
        const isMin = Math.abs(detail.priceFrom - minPrice) < 0.005;
        document.querySelectorAll('[data-dp-price-prefix]').forEach((el) => {
          el.hidden = !isMin;
        });
      }
    }

    // Der Betrag oben ist der Preis der gewählten Kachel – der Hinweis darunter nennt
    // das Format dazu (Serverseitig: Vorauswahl), damit „ab 16,14 €“ nicht mit dem
    // ab-Preis des Produkts in Titel/Kollektionskarte (günstigstes Format) verwechselt wird.
    if (detail.name) {
      document.querySelectorAll('[data-dp-price-format]').forEach((el) => {
        el.textContent = detail.name;
      });
    }

    // Große Formate (designerDpi < 300, dp-format-map.json): „bis zu 174 dpi – für Wandabstand“.
    // Vorlage mit {dpi} aus data-dp-format-note-template; bei 300 dpi bleibt der Hinweis versteckt.
    const dpi = Number(detail.designerDpi);
    document.querySelectorAll('[data-dp-format-note]').forEach((el) => {
      const show = Number.isFinite(dpi) && dpi > 0 && dpi < 300;
      el.hidden = !show;
      if (show) el.textContent = (el.dataset.dpFormatNoteTemplate || 'Große Formate werden mit bis zu {dpi} dpi gedruckt – für Wandabstand gedacht.').replace('{dpi}', String(dpi));
    });

    // Staffel-Upsell: Zeile „2 Stück ab … – der zweite nur +…" und Tabelle je Kachel aus detail.tiers
    // (dp-format-map.json, build-format-prices.mjs). Nur echte Staffelzeilen, nichts interpoliert;
    // ohne 2er-Staffel bleibt der Block versteckt. Bei einem Event ohne tiers (älteres Modul) bleibt
    // der serverseitige Stand der Vorauswahl stehen.
    if (Array.isArray(detail.tiers)) {
      const tiers = detail.tiers.filter((t) => Number.isInteger(t?.quantity) && typeof t.price === 'number').sort((a, b) => a.quantity - b.quantity);
      const one = tiers.find((t) => t.quantity === 1);
      const two = tiers.find((t) => t.quantity === 2);
      const extra = one && two && two.price > one.price ? Math.round((two.price - one.price) * 100) / 100 : null;
      document.querySelectorAll('[data-dp-upsell]').forEach((root) => {
        root.hidden = extra == null;
        if (extra == null) return;
        const each = Math.round((two.price / 2) * 100) / 100;
        const fill = (template) => template.replace('{tier2}', euro.format(two.price)).replace('{extra}', euro.format(extra)).replace('{each}', euro.format(each)).replace('{one}', euro.format(one.price));
        const text = root.querySelector('[data-dp-upsell-text]');
        if (text) text.textContent = fill(root.dataset.dpUpsellTemplate || '2 Kalender für {tier2}');
        const sub = root.querySelector('[data-dp-upsell-sub]');
        if (sub) sub.textContent = fill(root.dataset.dpUpsellSubTemplate || 'je Stück {each} statt {one} – der zweite nur +{extra}');
      });
    }

    // Papier/Bindung (QA 2026-09-21 F-01): der Betrag oben gilt für detail.selectedOptions (dp-format-picker.js
    // löst die Kombination gegen products[dpId].options auf). Wörter im Hinweis nachziehen; ohne Datensatz
    // (optionsResolved=false) bleibt der Standardpreis stehen und der Hinweis data-dp-option-note erscheint.
    const selected = detail.selectedOptions;
    if (selected && typeof selected === 'object') {
      for (const group of Object.keys(OPTION_DEFAULTS)) {
        const label = OPTION_LABELS[group]?.[selected[group]];
        if (label) document.querySelectorAll(`[data-dp-price-${group}]`).forEach((el) => { el.textContent = label; });
      }
      const inline = document.querySelector('[data-dp-price-paper], [data-dp-price-binding]');
      const standard = detail.optionIsStandard !== false;
      document.querySelectorAll('[data-dp-price-combo]').forEach((el) => {
        const parts = Object.keys(OPTION_DEFAULTS).filter((group) => selected[group] !== OPTION_DEFAULTS[group]).map((group) => selectedOptionLabel(group));
        const show = !inline && !standard && parts.length > 0;
        el.hidden = !show;
        el.textContent = show ? ` · ${parts.join(' · ')}` : '';
      });
      document.querySelectorAll('[data-dp-option-note]').forEach((el) => { el.hidden = detail.optionsResolved !== false; });
    }

    // Lieferzeit: Gruppe nur zeigen, wenn der Lieferant für dieses Format Express führt. Aufschlag und
    // Tage kommen aus der Format-Map (detail.express), nicht aus dem Theme — sonst versprechen wir Zahlen,
    // die der Warenkorb nicht einhält (Inhaber 2026-09-24).
    applySpeedOffer(detail.express, detail.deliveryDays);

    currentFormat = detail;
    applySpeedPrices();
    applyPriceWithSpeed();
    applyDesignerLinks();
  };

  /* ── Lieferzeit ─────────────────────────────────────────────────────────── */

  const speedGroup = document.querySelector('[data-dp-speed-group]');
  const selectedSpeed = () => document.querySelector('[data-dp-speed]:checked')?.value || 'standard';
  let expressOffer = null;

  const dayLabel = (days) => {
    const m = /^(\d+)-(\d+)$/.exec(String(days ?? ''));
    if (!m) return null;
    return m[1] === m[2] ? `${m[1]} Werktage` : `${m[1]}–${m[2]} Werktage`;
  };
  /** Werktage aus „5-5“ (bei einer Spanne die längere Seite – lieber zu spät als zu früh versprochen). */
  const dayCount = (days) => {
    const m = /^(\d{1,3})(?:-(\d{1,3}))?$/.exec(String(days ?? '').trim());
    const n = m ? Number(m[2] ?? m[1]) : NaN;
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  /**
   * Die Zeilen nennen ein Datum, keine Zahl („voraussichtlich Mo., 6. Okt.“). Gerechnet wird in
   * assets/dp-lieferdatum.js – dieselbe Rechnung wie im Designer; hier wird nur die Werktagszahl
   * gesetzt und um ein Nachziehen gebeten. Lädt das Modul nicht, bleibt der serverseitige Text
   * („in 5 Werktagen“) stehen.
   */
  function applyDeliveryDays(standardDays, expressDays) {
    const setzen = (sel, days) => {
      const n = dayCount(days);
      if (n == null) return;
      document.querySelectorAll(sel).forEach((el) => { el.setAttribute('data-dp-delivery-days', String(n)); });
    };
    setzen('[data-dp-speed-days-standard]', standardDays);
    setzen('[data-dp-speed-days-express]', expressDays);
    // Plakette „2 Tage früher“: der Unterschied in Worten statt eines Aufpreises.
    const diff = (dayCount(standardDays) ?? 0) - (dayCount(expressDays) ?? 0);
    document.querySelectorAll('.dp-product-main__speed-pill').forEach((el) => {
      if (diff > 0) { el.textContent = diff === 1 ? '1 Tag früher' : `${diff} Tage früher`; el.hidden = false; }
      else el.hidden = true;
    });
    document.dispatchEvent(new CustomEvent('dp:lieferdatum-refresh'));
  }

  function applySpeedOffer(offer, standardDays) {
    expressOffer = offer && Number(offer.surcharge) > 0 ? offer : null;
    if (!speedGroup) return;
    speedGroup.hidden = !expressOffer;
    if (!expressOffer) {
      // Kein Express für dieses Format: zurück auf Standard, damit keine Wahl stehen bleibt, die es nicht gibt.
      const std = document.querySelector('[data-dp-speed][value="standard"]');
      if (std && !std.checked) { std.checked = true; }
      return;
    }
    const tage = dayLabel(expressOffer.deliveryDays);
    if (tage) document.querySelectorAll('[data-dp-speed-days-express]').forEach((el) => { el.title = tage; });
    applyDeliveryDays(standardDays ?? '5-5', expressOffer.deliveryDays);
    applySpeedPrices();
  }

  /**
   * Jede Zeile zeigt ihren eigenen Gesamtpreis — kein „+ x €“. Ein Aufschlag neben der schnelleren
   * Option liest sich wie eine Strafe; zwei Preise nebeneinander sind eine Wahl (Inhaber 2026-09-24).
   */
  /**
   * Menge aus dem Preisrechner „Wie viele Kalender?" (dp:staffel-change). Die Lieferzeit-Karten
   * zeigen dann den Gesamtpreis für diese Menge – der Kunde vergleicht sonst zwei Preise, die
   * nicht zu der Menge passen, die er gerade eingestellt hat (Inhaber 2026-09-28).
   */
  let gewaehlteMenge = 1;

  /** Gesamtpreis der Staffelstufe des aktiven Formats; null, wenn diese Menge dort nicht geführt wird. */
  function staffelGesamt(menge) {
    const tiers = Array.isArray(currentFormat?.tiers) ? currentFormat.tiers : [];
    const treffer = tiers.find((t) => Number(t?.quantity) === menge && Number.isFinite(Number(t?.price)));
    return treffer ? Number(treffer.price) : null;
  }

  function applySpeedPrices() {
    if (!expressOffer) return;
    // Menge, die das aktive Format wirklich führt (nach einem Formatwechsel sonst eine Stufe zu viel).
    const menge = staffelGesamt(gewaehlteMenge) != null ? gewaehlteMenge : 1;
    const base = staffelGesamt(menge) ?? Number(currentFormat?.priceFrom);
    if (!Number.isFinite(base)) return;
    // Der Express-Aufschlag liegt auf der Sendung, nicht auf dem Stück – er kommt genau einmal dazu.
    const preise = { standard: base, express: Math.round((base + Number(expressOffer.surcharge)) * 100) / 100 };
    document.querySelectorAll('[data-dp-speed-price]').forEach((el) => {
      const wert = preise[el.dataset.dpSpeedPrice];
      if (Number.isFinite(wert)) el.textContent = euro.format(wert);
    });
    document.querySelectorAll('[data-dp-speed-qty]').forEach((el) => {
      el.textContent = menge > 1 ? ` · für ${menge} Kalender` : '';
      el.hidden = menge <= 1;
    });
  }

  // Der Rechner steht serverseitig auf 2 Stück (Staffel-Upsell) und meldet das beim ersten Rendern.
  // Das ist keine Wahl des Kunden – die Lieferzeit-Karten sollen beim Laden den Preis für ein Stück
  // zeigen. Erst ein echter Griff an den Regler oder an eine Mengen-Schaltfläche zählt.
  let mengeVomKunden = false;
  const rechner = document.querySelector('dp-staffel-rechner');
  if (rechner) {
    const merken = (event) => {
      if (event.target instanceof Element && event.target.closest('[data-dp-range], [data-dp-step]')) mengeVomKunden = true;
    };
    rechner.addEventListener('input', merken);
    rechner.addEventListener('change', merken);
    rechner.addEventListener('click', merken);
    rechner.addEventListener('keydown', merken);
  }

  document.addEventListener('dp:staffel-change', (event) => {
    const menge = Number(event.detail?.quantity);
    if (!mengeVomKunden || !Number.isInteger(menge) || menge < 1) return;
    gewaehlteMenge = menge;
    applySpeedPrices();
  });

  /** Betrag oben = Preis der Kachel plus Express-Aufschlag (einmal je Sendung, nicht je Stück). */
  function applyPriceWithSpeed() {
    const base = Number(currentFormat?.priceFrom);
    if (!Number.isFinite(base)) return;
    const zuschlag = selectedSpeed() === 'express' && expressOffer ? Number(expressOffer.surcharge) : 0;
    document.querySelectorAll('[data-dp-price-amount]').forEach((root) => {
      const amount = root.querySelector('.price') ?? root;
      amount.textContent = euro.format(Math.round((base + zuschlag) * 100) / 100);
    });
    // „ab“ steht nur beim günstigsten Format – mit Aufschlag ist es nicht mehr der günstigste Preis.
    // Beim Zurückschalten auf Standard kommt es zurück, aber nur wenn wir es selbst versteckt haben
    // (die Formatwahl entscheidet sonst eigenständig, siehe data-dp-price-min).
    document.querySelectorAll('[data-dp-price-prefix]').forEach((el) => {
      if (zuschlag > 0) {
        if (!el.hidden) el.dataset.dpPrefixRestore = '1';
        el.hidden = true;
      } else if (el.dataset.dpPrefixRestore === '1') {
        el.hidden = false;
        delete el.dataset.dpPrefixRestore;
      }
    });
    // Versandangabe unter dem Preis: ab 30 € berechnet der Checkout keinen Versand mehr.
    const inkl = Math.round((base + zuschlag) * 100) / 100 >= 30;
    document.querySelectorAll('[data-dp-price-shipping]').forEach((wrap) => {
      const link = wrap.querySelector('a');
      if (link) link.textContent = inkl ? 'inkl. Versand' : 'zzgl. Versand';
      const rest = wrap.querySelector('[data-dp-price-shipping-rest]');
      if (rest) rest.hidden = inkl;
    });
  }

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.hasAttribute('data-dp-speed')) return;
    applyPriceWithSpeed();
    applyDesignerLinks();
  });

  // Designer-Links der Seite (Haupt-CTA, Sticky-Leiste, Konfigurator-Band) tragen immer die
  // aktuelle Auswahl: ?product=&fmt= von den Formatkacheln, ?paper=/?binding= von den
  // Vorschau-Kacheln (data-dp-option). Vertrag: assets/dp-designer-link.js — dort liest der
  // Designer dieselben Parameter und öffnet genau diese Variante (Fotos eines angefangenen
  // Kalenders bleiben). `fmt`, nicht `format`: Shopify reserviert `format` und liefert sonst 404.
  let currentFormat = null;
  const OPTION_DEFAULTS = { paper: 'matt-170', binding: 'schwarz' };
  // Wortlaut im Preishinweis je Schlüssel (wie PAPER_CHOICES/BINDING_CHOICES im Designer, dp-designer-calendar-panel.js).
  const OPTION_LABELS = {
    paper: { 'matt-170': '170 g Bilderdruck matt', 'glanz-170': '170 g Bilderdruck glänzend', 'glanz-250': '250 g Bilderdruck glänzend' },
    binding: { schwarz: 'Wire-O-Bindung schwarz', silber: 'Wire-O-Bindung silber', weiss: 'Wire-O-Bindung weiß' },
  };
  const selectedOption = (group) => {
    const input = document.querySelector(`input[data-dp-option="${group}"]:checked`);
    return input ? input.value : '';
  };
  /** Beschriftung der gewählten Kachel („250 g glänzend“, „Silber“), sonst der Schlüssel. */
  const selectedOptionLabel = (group) => {
    const input = document.querySelector(`input[data-dp-option="${group}"]:checked`);
    const label = input?.id ? document.querySelector(`label[for="${CSS.escape(input.id)}"] .dp-product-main__swatch-label`) : null;
    return (label?.textContent || input?.value || '').trim();
  };
  const applyDesignerLinks = () => {
    document.querySelectorAll('a[data-dp-designer-href]').forEach((link) => {
      // Ohne Kachel-Auswahl (Formatliste noch nicht geladen oder gescheitert) bleibt der
      // serverseitige Link mit Produkt + Vorauswahl die Basis, sonst die nackte Designer-URL.
      const base = currentFormat ? link.dataset.dpDesignerHref : link.getAttribute('href') || link.dataset.dpDesignerHref;
      const url = new URL(base, window.location.origin);
      url.searchParams.delete('format');
      if (currentFormat?.dpProductId) url.searchParams.set('product', currentFormat.dpProductId);
      if (currentFormat?.key) url.searchParams.set('fmt', currentFormat.key);
      // ?pick=1: auf der Produktseite hat der Kunde das Format selbst gewaehlt – der gefuehrte Modus
      // fragt dann nicht noch einmal danach (Vertrag readDesignerParams in dp-designer-link.js).
      if (url.searchParams.get('fmt')) url.searchParams.set('pick', '1');
      // Versandart in den Designer mitnehmen (Vertrag dp-designer-link.js: ?speed=express).
      if (selectedSpeed() === 'express' && expressOffer) url.searchParams.set('speed', 'express');
      else url.searchParams.delete('speed');
      for (const group of Object.keys(OPTION_DEFAULTS)) {
        const value = selectedOption(group);
        if (value && value !== OPTION_DEFAULTS[group]) url.searchParams.set(group, value);
        else url.searchParams.delete(group);
      }
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  };

  // ?paper=/?binding= der Seiten-URL (Designer-Link „Zurück zur Produktseite“, Prüf-Links) wählen die
  // passende Kachel vor – nur Werte, die als Radio existieren (Systemgrenze: kein fremder Wert ins DOM).
  try {
    const params = new URLSearchParams(location.search);
    for (const group of Object.keys(OPTION_DEFAULTS)) {
      const wanted = String(params.get(group) ?? '').trim().toLowerCase();
      if (!wanted) continue;
      const input = [...document.querySelectorAll(`input[data-dp-option="${group}"]`)].find((el) => el.value === wanted);
      if (!(input instanceof HTMLInputElement) || input.checked) continue;
      input.checked = true;
      // change-Ereignis wie bei einem Klick: dp-format-picker.js meldet die Kachel mit den Preisen der Kombination neu.
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } catch { /* URL nicht lesbar – Standardauswahl bleibt */ }

  document.addEventListener('dp:format-change', (event) => applyFormat(event.detail));
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.dataset.dpOption) applyDesignerLinks();
  });
  // Falls das Modul schon vor diesem Skript gerendert hat: aktuellen Stand nachziehen.
  applyFormat(document.querySelector('dp-format-picker')?.selection);

  // Feste Kaufleiste (Audit P2-2): sichtbar, sobald der Haupt-CTA der
  // Kaufspalte oben aus dem Viewport verschwindet; wieder weg, wenn er
  // zurückkommt oder das Konfigurator-Band (eigener Kaufweg) im Bild ist.
  const stickyBar = document.querySelector('[data-dp-sticky]');
  const mainCta = document.querySelector('.dp-product-main__actions .dp-product-main__cta');
  if (stickyBar && mainCta && 'IntersectionObserver' in window) {
    let ctaVisible = true;
    let connectorVisible = false;
    const update = () => {
      stickyBar.hidden = ctaVisible || connectorVisible;
    };
    new IntersectionObserver(
      ([entry]) => {
        // Sichtbar heißt: im Blickfeld. Liegt der Haupt-CTA NOCH unter dem Viewport, ist er nicht
        // sichtbar – die alte Bedingung (top > 0) hielt die Kaufleiste genau auf der Strecke versteckt,
        // auf der sie gebraucht wird (Conversion-Audit 2026-09-22).
        ctaVisible = entry.isIntersecting;
        update();
      },
      { threshold: 0 }
    ).observe(mainCta);
    if (connector) {
      new IntersectionObserver(
        ([entry]) => {
          connectorVisible = entry.isIntersecting;
          update();
        },
        { threshold: 0.15 }
      ).observe(connector);
    }
    stickyBar.querySelector('a[href^="#"]')?.addEventListener('click', (event) => {
      const target = document.querySelector(event.currentTarget.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      if (target === connector) expandConnector();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
